import { Link } from "react-router-dom";
import SmartLink from "@/components/SmartLink";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import IloveMeIcon from "@/components/IloveMeIcon";
import { MEGA_MENU, SIGNIN_OPTIONS } from "@/lib/site";

export default function MegaMenu({ id, onNavigate }) {
    return (
        <motion.div
            id={id}
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
            className="absolute inset-x-5 top-full pt-3 sm:inset-x-8"
        >
            <div
                data-testid="nav-mega-menu"
                className="mx-auto max-w-4xl overflow-hidden rounded-3xl border border-[#08104F]/10 bg-[#FFFDFA] shadow-[0_30px_80px_rgba(8,16,79,0.18)]"
            >
                <div className="grid grid-cols-4 divide-x divide-[#08104F]/8 py-8">
                    {MEGA_MENU.map((section) => (
                        <div key={section.to} className="px-8">
                            <SmartLink
                                to={section.to}
                                onClick={onNavigate}
                                className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#0047BB] hover:text-[#08104F]"
                            >
                                {section.title === "ilove.me" ? <IloveMeIcon className="inline-flex items-center gap-1" /> : section.title}
                            </SmartLink>
                            <ul className="mt-4 space-y-1">
                                {section.items.map((item) => (
                                    <li key={item.to}>
                                        <SmartLink
                                            to={item.to}
                                            onClick={onNavigate}
                                            className="-mx-3 block rounded-xl px-3 py-2 text-[15px] font-medium text-[#08104F] transition-colors duration-200 hover:bg-[#B2D0FF]/20 hover:text-[#0047BB]"
                                        >
                                            {item.label}
                                        </SmartLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                    <div className="px-8">
                        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#0047BB]">Entrar</p>
                        <ul className="mt-4 space-y-1">
                            {SIGNIN_OPTIONS.map((option) => (
                                <li key={option.href}>
                                    <a
                                        href={option.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid={`mega-${option.testId}`}
                                        className="-mx-3 block rounded-xl px-3 py-2 text-[15px] font-medium text-[#08104F] transition-colors duration-200 hover:bg-[#B2D0FF]/20 hover:text-[#0047BB]"
                                    >
                                        {option.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="flex items-center justify-between gap-6 border-t border-[#08104F]/8 bg-[#F3EDE6]/60 px-8 py-5">
                    <div>
                        <p className="font-display text-base text-[#08104F]">Fale com um especialista</p>
                        <p className="mt-0.5 text-sm text-[#3A4768]">
                            Diagnóstico gratuito e sem compromisso para entender a rotina do seu negócio.
                        </p>
                    </div>
                    <Link
                        to="/contato"
                        onClick={onNavigate}
                        data-testid="btn-mega-menu-cta-diagnostic"
                        className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-[#08104F] px-5 py-2.5 text-sm font-medium text-white transition-all duration-200 hover:bg-[#0047BB] active:scale-[0.97]"
                    >
                        Falar com especialista
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                </div>
            </div>
        </motion.div>
    );
}
